module.exports = __webpack_public_path__ + "img/support_a4.dd44ab9d.png";